import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-mobile-pass-modal',
  templateUrl: './mobile-pass-modal.component.html',
  styleUrls: ['./mobile-pass-modal.component.scss']
})
export class MobilePassModalComponent implements OnInit {
  @Input() url: string;

  constructor() { }

  ngOnInit() {
  }

}
